// extracted by mini-css-extract-plugin
export default {"removeInterval":"RemoveInterval_removeInterval__jQWA8","removeIntervalAction":"RemoveInterval_removeIntervalAction__1QfQw"};